const getFormatCount = (count) => {
    if (count < 1000) {
      return count.toString();
    } else if (count >= 1000 && count < 1000000) {
      return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    } else {
      return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
  };

export default getFormatCount;